import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Industries from './pages/Industries';
import Products from './pages/Products';
import About from './pages/About';
import Contact from './pages/Contact';
import './App.css';

// ScrollToTop component to handle scroll on route change
const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top instantly when pathname changes (page navigation)
    window.scrollTo({
      top: 0,
      behavior: 'instant' as ScrollBehavior
    });
  }, [pathname]);

  return null;
};

// HomePage component combining Home and Products
const HomePage: React.FC = () => {
  return (
    <>
      <section id="home">
        <Home />
      </section>
      <section id="products">
        <Products />
      </section>
    </>
  );
};

// Layout component that wraps all pages
const Layout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return (
    <>
      <Navbar />
      <main className="main-content">
        {children}
      </main>
      <Footer />
    </>
  );
};

function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Routes>
          <Route path="/" element={<Layout><HomePage /></Layout>} />
          <Route path="/products" element={<Layout><HomePage /></Layout>} />
          <Route path="/industries" element={<Layout><Industries /></Layout>} />
          <Route path="/about" element={<Layout><About /></Layout>} />
          <Route path="/contact" element={<Layout><Contact /></Layout>} />
          {/* Fallback to home for unknown routes */}
          <Route path="*" element={<Layout><HomePage /></Layout>} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
